// extracted by mini-css-extract-plugin
module.exports = {"container":"PlayersList_container__3i1sV","playerShimmer":"PlayersList_playerShimmer__1O8Dy"};